import { IconTypes } from './Icons'

export default function CrossOutlined({
  color = '#202020',
  fontSize = '1.6rem',
  rotate = 0,
  className = '',
}: IconTypes) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      style={{
        width: '1em',
        height: '1em',
        fontSize,
        transform: `rotate(${rotate}deg)`,
      }}
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M6 18.5L18 6.5M6 6.5L18 18.5'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
